import {Component, OnInit, Input} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Source} from 'app/models/source.enum'
import {StoryboardService} from 'app/services/storyboard.service';
import {Storyboard} from 'app/models/storyboard';
import {AssetsFactory} from 'app/services/assets.factory.services'
import {ModalStoryboardComponent} from 'app/shared/components/modal-storyboard/modal-storyboard.component';
import {ColumnSortComponent} from 'app/shared/components/column-sort/column-sort.component';
import {Router, ActivatedRoute} from '@angular/router';
import {GoogleTagManagerService} from '../../services/google-tag-manager.service';

@Component({
    selector: 'app-storyboards',
    templateUrl: './storyboards.component.html',
    styleUrls: ['./storyboards.component.scss']
})
export class StoryboardsComponent extends ColumnSortComponent implements OnInit {

    @Input() hideAddButton: boolean;
    @Input() hideModifyButton: boolean;
    @Input() disableDrop: boolean;

    bsModalRef: BsModalRef;
    openContent: Array<string> = new Array();
    lastEvaluatedKey: any;

    constructor(
      private router: Router,
      private storyboardService: StoryboardService,
      private modalService: BsModalService,
      private activatedRoute: ActivatedRoute,
      private assetsFactory: AssetsFactory,
      private gtmService: GoogleTagManagerService,
    ) {

        super(assetsFactory, gtmService);
        this.assetType = Source.Storyboard;
    }

    override ngOnInit() {
        this.getAll();
    }
    ngOnDestroy() {
        if (this.bsModalRef)
            this.bsModalRef.content.close.unsubscribe();
    }
    onAdd() {
        this.showModal(null, 'ADD STORYBOARD', 'ADD STORYBOARD');
    }

    onEdit(storyboard: Storyboard) {
        this.showModal(storyboard, 'EDIT STORYBOARD', 'SAVE STORYBOARD');
    }

    onDelete(storyboard: Storyboard) {
        this.storyboardService
            .delete(storyboard.id)
            .subscribe((storyboards) => this.getAll());
    }

    onView(storyboard: Storyboard) {
        this.gtmService.pushEvent('Storyboard - Open panel');
        this.router.navigate(['storyboard', storyboard.id],
            {relativeTo: this.activatedRoute});
    }

    onContentState(data, state) {
        if (state) {
            this.openContent.push(data.id);
            const gtmData = {
                parentParams: this.activatedRoute.snapshot.parent.params,
            };
            this.gtmService.pushVirtualPageView('storyboard', data.id, gtmData);
        } else {
            this.openContent = this.openContent.filter((c) => c !== data.id);
        }
    }

    isContentShow(id) {
        return this.openContent.some((c) => c === id);
    }

    onSave(storyboard: Storyboard) {
        this.storyboardService
            .update(storyboard)
            .subscribe((storyboards) => this.getAll());
    }

    getNext() {
        this.getAll(this.lastEvaluatedKey);
    }

    getAll(lastEvaluatedKey?: string): void {
        this.storyboardService
            .getAll(lastEvaluatedKey)
            .subscribe(data => {
                //        const storyboards = this.assets && lastEvaluatedKey ?
                //                            this.assets.concat(data.Items) : data.Items;
                this.getListSorted(this.sort, this.direction).subscribe(r => {this.assets = r.Items});
                this.lastEvaluatedKey = data.LastEvaluatedKey;
            });
    }

    private showModal(storyboard: Storyboard, headerTitle: string, buttonTitle: string) {
        this.bsModalRef = this.modalService.show(ModalStoryboardComponent, {
            class: 'modal-lg',
            backdrop: 'static'
        });
        if (storyboard) {
            this.bsModalRef.content.storyboard = storyboard;
        }
        this.bsModalRef.content.title = headerTitle;
        this.bsModalRef.content.buttonTitle = buttonTitle;

        this.bsModalRef.content.close.subscribe(() => {
            this.getAll();
            this.bsModalRef.hide();
            this.bsModalRef.content.close.unsubscribe();
        })

    }
}
